import { i18n } from '@shared/i18n';
import IdField from '@shared/fields/id-field';
import BooleanField from '@shared/fields/boolean-field';
import DateTimeRangeField from '@shared/fields/date-time-range-field';
import DateTimeField from '@shared/fields/date-time-field';
import { GenericModel } from '@shared/model/generic-model';
import StringField from '@shared/fields/string-field';
import ImagesField from '@shared/fields/images-field';
import { ProgramField } from '@modules/program/program-field';
import { SubprogramField } from '@modules/subprogram/subprogram-field';
import { PlayerField } from '@modules/player/player-field';
import { CoachField } from '@modules/coach/coach-field';


function label(name) {
  return i18n(`entities.team.fields.${name}`);
}

const fields = {
  id: new IdField('id', label('id')),
  name: new StringField('name', label('name'), {
    "required": true,
  }),
  abcName: new StringField('name', label('name'), {
    "required": true,
  }),
  logo: new ImagesField(
    'logo',
    label('logo'),
    (subpropertyId, teamId) => `subproperties/${subpropertyId}/teams/${teamId}/logo`,
    {
      "required": true,
      "max": 1,
    }
  ),
  createdAt: new DateTimeField(
    'createdAt',
    label('createdAt'),
  ),
  updatedAt: new DateTimeField(
    'updatedAt',
    label('updatedAt'),
  ),
  createdAtRange: new DateTimeRangeField(
    'createdAtRange',
    label('createdAtRange'),
  ),
  program: ProgramField.relationToOne('program', label('program'), {
    "required": true,
  }),
  subprogram: SubprogramField.relationToOne('subprogram', label('subprogram'), {
    "required": true,
  }),
  players: PlayerField.relationToOne('player', label('players'), {
    "required": true,
  }),
  coaches: CoachField.relationToOne('coaches', label('coaches'), {
    "required": true,
  }),
  isMatched: new BooleanField('isMatched', label('isMatched'), {}),
};

export class TeamModel extends GenericModel {
  static get fields() {
    return fields;
  }
}
